import { Checkbox } from "primereact/checkbox";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef, useState } from "react";
import styled from "styled-components";

import {
  FilterPanelStyled,
  FilterTriggerStyled,
  FilterValueStyled,
} from "./styled";

const OptionLabelStyled = styled.label`
  cursor: pointer;

  color: var(--brand-gray-700);
  font-size: 1rem;
`;

const OptionDividerStyled = styled.div`
  border-top: 1px solid var(--brand-gray-200);
`;

export interface IColumnsFilterOption {
  key: string;
  header: string;
}

export function ColumnsFilter({
  options,
  value,
  onChange,
}: {
  options: IColumnsFilterOption[];
  value: string[];
  onChange: (columnKeys: string[]) => void;
}) {
  const panel = useRef<OverlayPanel>(null);
  const [open, setOpen] = useState(false);

  const selected = value ?? [];
  const allSelected = selected.length === options.length;

  const toggle = (columnKey: string) => {
    onChange(
      selected.includes(columnKey)
        ? selected.filter((item) => item !== columnKey)
        : [...selected, columnKey]
    );
  };

  return (
    <>
      <FilterTriggerStyled
        type="button"
        data-testid="columns_multiselect_OrderTable"
        className="flex align-items-center gap-2"
        onClick={(e) => {
          panel.current?.toggle(e);
          setOpen((wasOpen) => !wasOpen);
        }}
      >
        Columns shown:
        <FilterValueStyled>
          {allSelected ? "all" : `${selected.length} of ${options.length}`}
        </FilterValueStyled>
        <i className={open ? "pi pi-chevron-up" : "pi pi-chevron-down"} />
      </FilterTriggerStyled>

      <FilterPanelStyled ref={panel} onHide={() => setOpen(false)}>
        <div className="flex align-items-center gap-3 pb-3">
          <Checkbox
            inputId="columnsFilterAll"
            data-testid="columns_all_OrderTable"
            checked={allSelected}
            onChange={() => onChange(options.map((option) => option.key))}
          />
          <OptionLabelStyled htmlFor="columnsFilterAll">
            All columns
          </OptionLabelStyled>
        </div>

        <OptionDividerStyled />

        {options.map((option) => (
          <div key={option.key} className="flex align-items-center gap-3 pt-3">
            <Checkbox
              inputId={`columnsFilter-${option.key}`}
              data-testid={`columns_${option.key}_OrderTable`}
              checked={selected.includes(option.key)}
              onChange={() => toggle(option.key)}
            />
            <OptionLabelStyled htmlFor={`columnsFilter-${option.key}`}>
              {option.header}
            </OptionLabelStyled>
          </div>
        ))}
      </FilterPanelStyled>
    </>
  );
}
